module.exports = __webpack_public_path__ + "static/media/o6.a603d996.png";